<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>



// WEBPACK FOOTER //
// src/pages/thirdAnniversary/App.vue